import { FC, useCallback, useEffect, useState } from 'react';

import moment from 'moment';
import styled, { css } from 'styled-components';

import { SearchBarSingleDatePicker } from '@domain/carRental/searchBar/home/dateSelection/dateSelect/desktopDateSelect';
import ResponsiveSingleDateSelect from '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveSingleDateSelect';
import { useBreakpoint } from '@contexts/breakpoints';
import {
  DateType,
  formatMomentDate,
  formatShortLocalDate,
} from '@utils/dateUtil';

import {
  Arrow,
  ErrorMessage,
  ErrorMessageContainer,
} from '../carRentalAutoComplate/styled';

export const SearchBarDateInputWrapper = styled.div<{
  alignVertical?: boolean;
}>`
  &&& {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: ${({ theme }) => theme.palette.white};

    ${({ alignVertical }) =>
      alignVertical &&
      css`
        .date-input-component {
          width: 100% !important;
        }
      `}
  }
`;

export interface IDateSelection {
  title: string;
  setDate: (value: moment.Moment) => void;
  date: moment.Moment | null;
  startDate?: DateType | null;
  endDate?: DateType | null;
  initialDate?: DateType | null;
  isOutsideRange?: ((day: moment.Moment) => boolean) | undefined;
  alignVertical?: boolean;
  hasError?: boolean;
}

const DateSelection: FC<IDateSelection> = ({
  title,
  initialDate,
  isOutsideRange,
  setDate,
  date,
  alignVertical,
  hasError = false,
}) => {
  const [localDate, setLocalDate] = useState<DateType | null>(
    initialDate || null
  );
  const [showDatepicker, setShowDatepicker] = useState(false);
  const [isCalendarReady, setIsCalendarReady] = useState(false);
  const { xl } = useBreakpoint();

  const handleCalendarReady = useCallback(() => {
    setIsCalendarReady(true);
  }, []);

  const handleDesktopPopoverVisibleChange = useCallback((visible: boolean) => {
    setIsCalendarReady(false);
    setShowDatepicker(visible);
  }, []);

  useEffect(() => {
    setLocalDate(date);
  }, [date]);

  const onDateChange = (date: moment.Moment | null) => {
    setLocalDate(date);
    setDate(date as moment.Moment);
  };

  return (
    <SearchBarDateInputWrapper alignVertical={alignVertical}>
      {xl ? (
        <SearchBarSingleDatePicker
          label={title}
          onDateChange={onDateChange}
          date={localDate}
          onReady={handleCalendarReady}
          inputComponent='shopAndFlyHomePageCarRental'
          error={hasError}
          placeholder=''
          popoverContentReady={isCalendarReady}
          popoverProps={{
            isOpen: showDatepicker,
            onVisibleChange: handleDesktopPopoverVisibleChange,
          }}
          // isOutsideRange={isOutsideRange}
        />
      ) : (
        <ResponsiveSingleDateSelect
          date={localDate}
          onDateChange={onDateChange}
          title={title}
          subTitle={formatShortLocalDate(formatMomentDate(localDate))}
          placeholder={title}
          drawerTitle='Tarih Arama'
          arrowIcon={true}
          inputComponent='shopAndFlyHomePageCarRental'
          error={hasError}
          isOutsideRange={isOutsideRange}
        />
      )}

      {hasError && (
        <ErrorMessageContainer>
          <Arrow />
          <ErrorMessage>Tarih seçiniz</ErrorMessage>
        </ErrorMessageContainer>
      )}
    </SearchBarDateInputWrapper>
  );
};
export default DateSelection;
